import {
  useEffect,
  useState,
} from 'react';
import {
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { ProductAction } from 'src/actions/product.action';
import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
  MAXIMUM_IMAGES,
} from 'src/utils/constants';
import { getProductStatus } from 'src/utils/utils';
import ConfirmDialog from '../ConfirmDialog';
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
  Button,
  Select,
  MenuItem,
} from '@material-ui/core';
import CreateEditDialog from './CreateEditDialog';

import numeral from 'numeral';
import ProductPrice from './ProductPrice';

const ProductLookupDetail = ({ ...rest }) => {
  const maximumImages = MAXIMUM_IMAGES;
  const dispatch = useDispatch()
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [limit, setLimit] = useState(DEFAULT_ROW_PER_PAGE);
  const [page, setPage] = useState(0);
  const { role } = useSelector(state => state.profile);
  const { items, total, filter } = useSelector(state => state.product);
  const [confirm, setConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selected, setSelected] = useState({});
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const payload = {
      ...filter,
      limit: limit,
      page: page,
    };
    dispatch(ProductAction.updateFilter(payload));
    dispatch(ProductAction.list(page, limit))
  }, [page, limit])

  const handleSelectAll = (event) => {
    let newSelectedProductIds;

    if (event.target.checked) {
      newSelectedProductIds = items.map((product) => product.id);
    } else {
      newSelectedProductIds = [];
    }

    setSelectedProductIds(newSelectedProductIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedProductIds.indexOf(id);
    let newSelectedProductIds = [];

    if (selectedIndex === -1) {
      newSelectedProductIds = newSelectedProductIds.concat(selectedProductIds, id);
    } else if (selectedIndex === 0) {
      newSelectedProductIds = newSelectedProductIds.concat(selectedProductIds.slice(1));
    } else if (selectedIndex === selectedProductIds.length - 1) {
      newSelectedProductIds = newSelectedProductIds.concat(selectedProductIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedProductIds = newSelectedProductIds.concat(
        selectedProductIds.slice(0, selectedIndex),
        selectedProductIds.slice(selectedIndex + 1)
      );
    }

    setSelectedProductIds(newSelectedProductIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleConfirmOpen = (type, product) => {
    setSelected(product);
    setConfirmType(type);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      setTitle("Xoá bản ghi")
      setContent(`Xác nhận xoá bản ghi `)
    }
    setConfirm(true);
  };

  const onConfirm = () => {
    setConfirm(false);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      dispatch(ProductAction.del(selected.id))
      return;
    }
  }

  const handleConfirmClose = () => {
    setConfirm(false);
  };

  const onSelected = (id) => {
    dispatch(ProductAction.findOne(id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const approve = async (id, trang_thai_duyet) => {
    const question = trang_thai_duyet == 1 ? "Xác nhận duyệt đơn này?" : "Xác nhận từ chối đơn này?" ;
    if (window.confirm(question)) {
      try {
        const response = await dispatch(ProductAction.approve(id, { trang_thai_duyet }));
        if (typeof response.channel !== 'undefined') alert("[Thông báo từ '"+response.channel+"']\n"+response.message+(response.status != "Unknown" ? (" ("+response.status+")") : ""));
        else if (typeof response.code !== 'undefined' && typeof response.msg !== 'undefined') alert("[Lỗi]\n"+response.msg)
      } catch (error) {
        if (typeof error.code !== 'undefined' && typeof error.msg !== 'undefined') alert("[Lỗi]\n"+error.msg)
      }
    } else {
      
    }
  };

  const setTrangThai = async (id, trang_thai) => {
    const question = trang_thai == 'SUCCESS' ? "Xác nhận đặt trạng thái 'Thành công'?" : "Xác nhận đặt trạng thái 'Thất bại'?" ;
    if (window.confirm(question)) {
      try {
        const response = await dispatch(ProductAction.setTrangThai(id, { trang_thai }));
        if (typeof response.channel !== 'undefined') alert("[Thông báo từ '"+response.channel+"']\n"+response.message+(response.status != "Unknown" ? (" ("+response.status+")") : ""));
        else if (typeof response.code !== 'undefined' && typeof response.msg !== 'undefined') alert("[Lỗi]\n"+response.msg)
      } catch (error) {
        if (typeof error.code !== 'undefined' && typeof error.msg !== 'undefined') alert("[Lỗi]\n"+error.msg)
      }
    } else {
      
    }
  };

  const setColor = (value) => {
      if (value == 'MOBIFONE') return 'green';
      else if (value == 'VINAPHONE') return 'blue';
      else if (value == 'VIETTEL') return 'red';
      else return '#000000';
  };

  return (
    <Card {...rest} style={{ width: "100%"}}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: 1050 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  #
                </TableCell>
                <TableCell>
                  Loại sản phẩm
                </TableCell>
                <TableCell>
                  Tên
                </TableCell>
                <TableCell>
                  Hình ảnh
                </TableCell>
                <TableCell>
                  Giá
                </TableCell>
                <TableCell>
                  Ngày tạo
                </TableCell>
                {/* <TableCell>
                  Người đăng
                </TableCell> */}
                {/* <TableCell>
                  Người chỉnh cuối
                </TableCell> */}
                <TableCell>
                  Trạng thái
                </TableCell>
                <TableCell>
                  Thao tác
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items && Object.values(items).length > 0 && items.slice(page * limit, page * limit + limit).map((product, index) => (
                <TableRow
                  hover
                  key={product.id}
                  selected={selectedProductIds.indexOf(product.id) !== -1}
                >
                  <TableCell>
                    {page * limit + index + 1}
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {product.product_type == "xe_may_dien" && <span style={{ }}>Xe máy điện</span>}
                      {product.product_type == "xe_dap_dien" && <span style={{ }}>Xe đạp điện</span>}
                      {product.product_type == "ac_quy" && <span style={{ }}>Ắc quy</span>}
                      {product.product_type == "pin" && <span style={{ }}>Pin</span>}
                      {product.product_type == "phu_tung" && <span style={{ }}>Phụ tùng</span>}
                      {product.product_type == "khac" && <span style={{ }}>Khác</span>}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {product.name}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color="textPrimary" variant="body1">
                      {product.images && product.images.length > 0 && (() => {
                        const minImage = product.images.reduce((min, img) =>
                          img.index < min.index ? img : min
                        );
                        return (
                          <img
                            style={{ height: 30 }}
                            src={minImage.image}
                            alt={product.title || ''}
                          />
                        );
                      })()}
                    </Typography>
                  </TableCell>
                  <TableCell width={200}>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {/* {(Number(product.price_new) > 0 && Number(product.price_new) < Number(product.price)) ? (
                        <div>
                          <span style={{ color: 'red', fontWeight: 'bold' }}>
                            {numeral(product.price_new).format('0,0')}₫
                          </span>
                          &nbsp;
                          <span className='price-old' style={{ textDecoration: 'line-through', color: '#888' }}>
                            {numeral(product.price).format('0,0')}₫
                          </span>
                        </div>
                      ) : (
                        <div>
                          <span style={{ fontWeight: 'bold' }}>
                            {numeral(product.price).format('0,0')}₫
                          </span>
                        </div>
                      )} */}
                      <ProductPrice product={product} />
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {moment(product.createdAt).format('DD-MM-YYYY HH:mm:ss')}
                    </Typography>
                  </TableCell>
                  {/* <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {product.username_dang_bai}
                    </Typography>
                  </TableCell> */}
                  {/* <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {product.username_chinh_sua_cuoi_cung}
                    </Typography>
                  </TableCell> */}
                  <TableCell>
                    <Typography
                      color=""
                      variant="body1"
                    >
                      {product.trang_thai == "con_hang" && <span style={{ color: 'green' }}>Còn hàng</span>}
                      {product.trang_thai == "het_hang" && <span style={{ color: 'red' }}>Hết hàng</span>}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <IconButton aria-label="edit" onClick={() => onSelected(product.id)}>
                      <Edit3Icon color='green' />
                    </IconButton>
                    <IconButton aria-label="delete" onClick={() => handleConfirmOpen(CONFIRM_TYPES.DELETE, product)}>
                      <Trash2Icon color='red' />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
      />
      <CreateEditDialog open={open} handleClose={handleClose} type={"EDIT"} />
      <ConfirmDialog open={confirm} title={title} content={content || `Xác nhận xoá bản ghi `} highlight={selected.ten_goi_cuoc} handleClose={handleConfirmClose} handleConfirm={onConfirm} />
    </Card>
  );
};

export default ProductLookupDetail;
